<style lang="scss">
  .navigation-overlay {
    pointer-events: none;
    position: fixed;
    width: 100vw;
    height: calc(100vh - 97px);
    height: calc((100 * var(--vh)) - 97px);
    z-index: 1;
    top: 97px;
    left: 0;
    opacity: 0;
    transition: opacity 0.2s, visibility 0s 0.2s;
    background: #ffffff;
    &.active {
      visibility: visible;
      overflow: auto;
      pointer-events: auto;
      opacity: 1;
      transition: opacity 0.2s;
    }
  }

  /**
 * Disable body scrolling when overlayer is visible
 */

  body.noscroll {
    overflow: hidden;
    width: 100vw;
    height: calc(100vh - 64px);
    height: calc(var(--vh, 1vh) * 100 - 64px); //vh fix from app.js
  }
</style>

<template>
  <div class="navigation-overlay bg-dark" v-cloak :class="{ active: $root.navigationIsVisble }">
    <slot></slot>
  </div>
</template>

<script>
  export default {};
</script>
